module.exports = __webpack_public_path__ + "static/img/fadongji.3446bcaf.svg";